// Countries Sihmo can pay photographers in - the same list as server/api-util/payoutCountries.js
// (payoutCountries.test.js on the server side checks that both are equal). Everybody else can
// still sign up, but is put on a waitlist.
export const PAYOUT_COUNTRIES = [
  'AT', 'BE', 'BG', 'CH', 'CY', 'CZ', 'DE', 'DK', 'EE', 'ES', 'FI', 'FR', 'GB', 'GR',
  'IE', 'IT', 'LT', 'LU', 'LV', 'MT', 'NL', 'NO', 'PL', 'PT', 'RO', 'SE', 'SI', 'SK',
];

// ISO 3166-1 alpha-2 (without uninhabited territories); the names come from Intl.DisplayNames.
const ALL_COUNTRY_CODES = (
  'AD AE AF AG AI AL AM AO AR AS AT AU AW AX AZ BA BB BD BE BF BG BH BI BJ BL BM BN BO BQ BR BS BT BW BY BZ ' +
  'CA CC CD CF CG CH CI CK CL CM CN CO CR CU CV CW CX CY CZ DE DJ DK DM DO DZ EC EE EG EH ER ES ET FI FJ FK FM FO FR ' +
  'GA GB GD GE GF GG GH GI GL GM GN GP GQ GR GT GU GW GY HK HN HR HT HU ID IE IL IM IN IQ IR IS IT JE JM JO JP ' +
  'KE KG KH KI KM KN KP KR KW KY KZ LA LB LC LI LK LR LS LT LU LV LY MA MC MD ME MF MG MH MK ML MM MN MO MP MQ MR MS MT ' +
  'MU MV MW MX MY MZ NA NC NE NF NG NI NL NO NP NR NU NZ OM PA PE PF PG PH PK PL PM PN PR PS PT PW PY QA RE RO RS RU RW ' +
  'SA SB SC SD SE SG SH SI SJ SK SL SM SN SO SR SS ST SV SX SY SZ TC TD TG TH TJ TK TL TM TN TO TR TT TV TW TZ ' +
  'UA UG US UY UZ VA VC VE VG VI VN VU WF WS XK YE YT ZA ZM ZW'
).split(' ');

export const isPayoutCountrySupported = code => PAYOUT_COUNTRIES.includes(String(code || '').toUpperCase());

const nameOf = (code, locale) => {
  try {
    return new Intl.DisplayNames([locale || 'en'], { type: 'region' }).of(code) || code;
  } catch (e) {
    return code;
  }
};

/**
 * Options for the country select, in the reader's language:
 * { supported: [{code, name}], other: [{code, name}] }, each sorted by name.
 */
export const countryOptions = locale => {
  const collator = new Intl.Collator(locale || 'en');
  const all = ALL_COUNTRY_CODES.map(code => ({ code, name: nameOf(code, locale) })).sort((a, b) =>
    collator.compare(a.name, b.name)
  );
  return {
    supported: all.filter(c => isPayoutCountrySupported(c.code)),
    other: all.filter(c => !isPayoutCountrySupported(c.code)),
  };
};

export const countryName = nameOf;

/**
 * The country of a signed-in photographer who is on the payout waitlist, else null.
 * (privateData.payoutCountry is set by /api/payout-country at sign-up.)
 */
export const waitlistCountryOf = user => {
  const privateData = user && user.attributes && user.attributes.profile && user.attributes.profile.privateData;
  const country = privateData && privateData.payoutCountry;
  return country && !isPayoutCountrySupported(country) ? String(country).toUpperCase() : null;
};
